import { render, staticRenderFns } from "./InsuranceDetail.vue?vue&type=template&id=2b694310&scoped=true"
import script from "./InsuranceDetail.vue?vue&type=script&lang=js"
export * from "./InsuranceDetail.vue?vue&type=script&lang=js"
import style0 from "./InsuranceDetail.vue?vue&type=style&index=0&id=2b694310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b694310",
  null
  
)

export default component.exports